module.exports = "<svg version=\"1.1\" id=\"Réteg_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 500 500\" enable-background=\"new 0 0 500 500\" xml:space=\"preserve\"><g><circle fill=\"#F69EA6\" cx=\"250\" cy=\"250\" r=\"169\"></circle><path fill=\"#EF4750\" d=\"M250,429c-98.7,0-179-80.3-179-179c0-98.7,80.3-179,179-179c98.7,0,179,80.3,179,179 C429,348.7,348.7,429,250,429z M250,90.9c-87.7,0-159.1,71.4-159.1,159.1S162.3,409.1,250,409.1S409.1,337.7,409.1,250 S337.7,90.9,250,90.9z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/view/CreatePOIDialog/circle.svg
// module id = 923
// module chunks = 0